waitUntil(() => {
  return window.sessionStorage.getItem("D003") || getParam("qa").indexOf("D003") > -1;
}).then(() => {

  console.log('abc');

  let exp_id = "D003";
  let variation = "v1";

  if(getParam("qa") && getParam("var")){
    variation = getParam("var");
  } else if(window.sessionStorage.getItem(exp_id)){
    variation = window.sessionStorage.getItem(exp_id);
  }

  window.sessionStorage.setItem(exp_id, variation);
  console.log(`init [${exp_id}] -- 0.05 -- ${variation}`);

  if (variation == 'v1') {  
    waitForElement('body').then(() => {
      document.body.insertAdjacentHTML("afterbegin", `
        <style>
          .shipping-bar {
            display: none !important;
          }
        </style>
      `);
    }).catch();
  }

  if (variation == 'v2') {  
    waitForElement('body').then(() => {
      document.body.insertAdjacentHTML("afterbegin", `
        <style>
          .mini-cart-timer {
            display: none !important;
          }
          .shipping-bar {
            display: block !important;
          }
        </style>
      `);
    }).catch();
  }

  if (variation == 'v3') {
    waitForElement('.header__secondary-links .header__icon-list').then((iconList) => {
      window.themeVariables.settings.cartType = 'page';
      document.querySelector('.cart-icon--visible').remove();
      document.querySelector('.cart-icon--hidden').classList.remove('cart-icon--hidden');
    }).catch();
  }

}).catch();
